import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

// Temps réel (serveur WebSocket Soketi, protocole Pusher) — même principe que core-app.
// Sans configuration, window.Echo reste null et l'application fonctionne sans temps réel.
window.Pusher = Pusher

const key = process.env.VUE_APP_PUSHER_APP_KEY
const host = process.env.VUE_APP_PUSHER_HOST

window.Echo = null

if (key && host) {
    try {
        const port = parseInt(process.env.VUE_APP_PUSHER_PORT) || 6002
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key,
            cluster: 'mt1',
            wsHost: host,
            wsPort: port,
            wssPort: port,
            forceTLS: (process.env.VUE_APP_PUSHER_SCHEME || 'https') === 'https',
            enabledTransports: ['ws', 'wss'],
            disableStats: true,
            // Canaux privés (notifications par boutique) : autorisés par l'API avec le
            // jeton Sanctum courant, lu à chaque abonnement (il change à la connexion).
            authorizer: (channel) => ({
                authorize: (socketId, callback) => {
                    const apiRoot = (process.env.VUE_APP_API_URL || '').replace(/\/api\/v1\/?$/, '')
                    fetch(apiRoot + '/broadcasting/auth', {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + (window.Ls?.get('auth.token') ?? ''),
                        },
                        body: JSON.stringify({socket_id: socketId, channel_name: channel.name}),
                    })
                        .then(response => response.ok ? response.json() : Promise.reject(response.status))
                        .then(data => callback(null, data))
                        .catch(error => callback(error, null))
                },
            }),
        })
    } catch (e) {
        window.Echo = null
    }
}
